module.exports = __webpack_public_path__ + "img/resp-team.da63e6fc.svg";